import { Factory } from 'fishery'

import { ShipmentIncident } from '../domain/ShipmentIncident'

class TestShipmentIncident extends Factory<ShipmentIncident> {
  severityError() {
    return this.params({
      code: 'confirmedDisruption',
      label: 'Confirmed Disruption',
    })
  }

  severityWarning() {
    return this.params({
      code: 'riskOfDelay',
      label: 'Risk of Delay',
    })
  }
}

export const testShipmentIncident = TestShipmentIncident.define(() => ({
  code: 'something',
  label: 'Something',
  remarks: [],
}))
